// Simple in-flight request deduplicator. Reused across components that fetch
// the same list on the same page load (StrictMode's double-mount + parallel
// consumers like OnboardingWizard would otherwise fire the request twice).
// Not a cache — the promise resolves and clears, so the next explicit load
// re-fetches fresh data.
import api from "@/lib/api";

const _inFlight = new Map();

export function dedupGet(url, params) {
  const key = params ? `${url}?${JSON.stringify(params)}` : url;
  if (_inFlight.has(key)) return _inFlight.get(key);
  const p = api.get(url, params ? { params } : undefined)
    .finally(() => { _inFlight.delete(key); });
  _inFlight.set(key, p);
  return p;
}
